import { apiClient } from "./apiClient";

import type {
  AdjustUserPointsData,
  AdjustUserPointsInput,
  PointsTransactionsData,
  PointsTransactionsQuery,
} from "../types/points.types";

const buildTransactionsQuery = (
  query: PointsTransactionsQuery = {},
): string => {
  const params = new URLSearchParams();

  if (query.limit !== undefined) {
    params.set(
      "limit",
      String(query.limit),
    );
  }

  if (query.cursor?.trim()) {
    params.set(
      "cursor",
      query.cursor.trim(),
    );
  }

  if (query.type) {
    params.set(
      "type",
      query.type,
    );
  }

  if (query.source?.trim()) {
    params.set(
      "source",
      query.source.trim(),
    );
  }

  const queryString =
    params.toString();

  return queryString
    ? `?${queryString}`
    : "";
};

export const pointsApi = {
  adjustUserPoints(
    uid: string,
    input: AdjustUserPointsInput,
  ) {
    return apiClient.post<AdjustUserPointsData>(
      `/users/${encodeURIComponent(
        uid,
      )}/points/adjust`,
      input,
    );
  },

  getUserTransactions(
    uid: string,
    query: PointsTransactionsQuery = {},
  ) {
    return apiClient.get<PointsTransactionsData>(
      `/users/${encodeURIComponent(
        uid,
      )}/points/transactions${buildTransactionsQuery(
        query,
      )}`,
    );
  },
};